export function anchorNav() {
    const $navWrapper = $(".anchor-nav-block");
    const $nav = $(".anchor-nav");
    const $navButtons = $nav.find(".anchor-item");
    const $navHeight = $nav.outerHeight();
    $(window).on("scroll load", function () {
        const $scrollPosition = $(window).scrollTop();
        const $navBlockTop = $navWrapper.offset().top;
        if ($scrollPosition >= $navBlockTop) {
            $nav.addClass("fixed");
        } else {
            $nav.removeClass("fixed");
        }
        $navButtons.each(function (index, navButton) {
            const $dataTarget = $(navButton).attr("href");
            const $targetTop = $($dataTarget).offset().top - $navHeight - 30;
            const $targetHeight = $($dataTarget).outerHeight();
            const $targetBottom = $targetTop + $targetHeight;
            if ($scrollPosition >= $targetTop && $scrollPosition < $targetBottom) {
                $(navButton).addClass("active");
                $navButtons.not(navButton).removeClass("active");
            } else {
                $(navButton).removeClass("active");
            }
        });
    });
    $navButtons.on("click", function (e) {
        e.preventDefault();
        const $dataTarget = $(this).attr("href");
        const $targetTop = $($dataTarget).offset().top;
        const $scrollTo = $targetTop - $navHeight;
        $("html, body").animate({
            scrollTop: $scrollTo
        }, 600);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorNav.js